module.exports = __webpack_public_path__ + "img/logo.494aaf3f.svg";